import { Injectable } from "@angular/core";
import { gql, Apollo, Query } from "apollo-angular";
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};

export type GetAllIdeaCommentByIdQuery = {
  getAllIdeaCommentById: { id: string; name: string; message: string; status: string; createdAt: Date, deletedAt: Date }[];
};
export type getAllIdeaCommentQueryVariables = Exact<{
  id: string;
}>;

export const GetAllCommentsByIdDocument = gql`
  query GetAllIdeaCommentById($id: String!) {
    getAllIdeaCommentById(id: $id) {
      id
      name
      message
      createdAt
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class GetAllCommentsByIdGQL extends Query<
  GetAllIdeaCommentByIdQuery,
  getAllIdeaCommentQueryVariables
> {
  document = GetAllCommentsByIdDocument;

  constructor(apollo: Apollo) {
    super(apollo);
  }
}
